import script from "./ConsultationList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConsultationList.vue?vue&type=script&lang=ts&setup=true"

import "./ConsultationList.vue?vue&type=style&index=0&id=20af0d44&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20af0d44"]])

export default __exports__